var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotEqual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a41c5",
    d: "m6.7647 8.9718c2.0177 0 4.0054-0.00998 6.0231-0.00998l1.4363-2.3681 1.7094 1.0382-0.80976 1.3348 2.2268 0.00499v2h-3.4447l-1.5872 2.6254 5.032-0.0043v2l-6.2528 0.0038-1.5525 2.553-1.7094-1.0382 0.91893-1.5086-1.9901-0.01v-1.9999l3.208-0.0057 1.5972-2.6155h-4.8052m-1.7647-7.9718c-1.11 0-2 0.9-2 2v14c0 1.1046 0.89543 2 2 2h14c1.1046 0 2-0.89543 2-2v-14c0-1.1046-0.89543-2-2-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not-equal.f25cfe85a3e7d94495fed4cc33348aa3.svg";
export { ForwardRef as ReactComponent };